var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOkLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
  viewBox: "0 0 26 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13 26a13 13 0 1 1 13-13 13 13 0 0 1-13 13M13 .5A12.5 12.5 0 1 0 25.5 13 12.5 12.5 0 0 0 13 .5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.06 5.55a3.86 3.86 0 1 0 3.86 3.86 3.86 3.86 0 0 0-3.86-3.86m0 5.46a1.6 1.6 0 1 1 1.6-1.6 1.6 1.6 0 0 1-1.6 1.59Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.43 16.34a6.11 6.11 0 0 0 2.51-1.08 1 1 0 1 0-1.31-1.64 4.52 4.52 0 0 1-2.62.77 4.63 4.63 0 0 1-2.64-.77 1 1 0 1 0-1.31 1.64 6.32 6.32 0 0 0 2.6 1.09l-2.22 2.32a1.06 1.06 0 0 0 .76 1.78 1 1 0 0 0 .75-.33L13 17.93l2.26 2.21a1.05 1.05 0 0 0 1.49-1.49ZM13 14.39"
})));
export default SvgOkLogo;